import { useCallback, useEffect, useState } from "react";
import { getCalidadNcpFicha } from "../api/calidad";
import type { CalidadNcpFicha } from "../types/calidad";

export function useCalidadNcpFicha(
  incidenciaId: number | null,
  enabled = true,
) {
  const [ficha, setFicha] = useState<CalidadNcpFicha | null>(null);
  const [loading, setLoading] = useState(enabled && incidenciaId !== null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!enabled || incidenciaId === null) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getCalidadNcpFicha(incidenciaId);
      setFicha(response);
    } catch {
      setError("No se pudo cargar la ficha NCp.");
    } finally {
      setLoading(false);
    }
  }, [enabled, incidenciaId]);

  useEffect(() => {
    if (!enabled || incidenciaId === null) {
      setFicha(null);
      setLoading(false);
      setError(null);
      return;
    }

    void reload();
  }, [enabled, incidenciaId, reload]);

  return {
    ficha,
    loading,
    error,
    reload,
    setFicha,
  };
}
